var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRewardPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#CDB16D",
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7E0C",
    d: "M512,256C512,115.166,396.831,0,256,0v512C396.831,512,512,396.832,512,256z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FCE5AA",
    cx: 256,
    cy: 256,
    r: 195
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDB16D",
    d: "M451,256c0-107.52-87.48-195-195-195v390C363.52,451,451,363.52,451,256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDB16D",
    d: "M384.394,214.281c-1.772-5.435-6.46-9.39-12.114-10.21l-71.045-10.327l-31.787-64.38 c-2.52-5.127-7.982-7.69-13.446-7.69s-10.928,2.563-13.447,7.69l-31.787,64.38l-71.045,10.327 c-5.654,0.82-10.342,4.775-12.114,10.195c-1.758,5.435-0.293,11.396,3.794,15.381l51.416,50.127l-12.129,70.767 c-0.967,5.625,1.349,11.31,5.962,14.663c4.66,3.384,10.794,3.792,15.791,1.144L256,332.948l63.56,33.398 c5.039,2.666,11.191,2.24,15.791-1.144c4.614-3.354,6.929-9.038,5.962-14.663l-12.144-70.767l51.431-50.127 C384.687,225.663,386.151,219.701,384.394,214.281z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7E0C",
    d: "M335.351,365.204c4.614-3.354,6.929-9.038,5.962-14.663l-12.144-70.767l51.431-50.127 c4.087-3.984,5.552-9.946,3.794-15.366c-1.772-5.435-6.46-9.39-12.114-10.21l-71.045-10.327l-31.787-64.38 c-2.52-5.127-7.982-7.69-13.446-7.69v211.274l63.56,33.398C324.599,369.013,330.751,368.588,335.351,365.204z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardPoints);
export default __webpack_public_path__ + "static/media/reward_points.1b055fe1feeb981ecb43b771e0b6072f.svg";
export { ForwardRef as ReactComponent };